import React from "react";

const Header = () => {
    return ( 
        
    <header className="header">
    <div className="header_overlay"></div>
    <div className="header_content d-flex flex-row align-items-center justify-content-start">
        <div style={{height:'100%',marginLeft:'-10px'}}>
            <a href="#">
                <div style={{height:'100% !important'}} className="d-flex flex-row align-items-center justify-content-start">
                <div style={{width:'90%',height:'100%',marginTop:'3%'}}><img src="/Assets/logo/header-logo.png" alt=""/></div>
                </div>
            </a>	
        </div>
        <div className="header_right d-flex flex-row align-items-center justify-content-start ml-auto">
            {/* <div className="user"><a href="#"><div><img src="/Assets/images/user.svg" alt="https://www.flaticon.com/authors/freepik"/><div>1</div></div></a></div>
            <div className="cart"><a href="cart.html"><div><img className="svg" src="/Assets/images/cart.svg" alt="https://www.flaticon.com/authors/freepik"/></div></a></div> */}
            <div id='phoneHeader' className="header_phone d-flex flex-row align-items-center justify-content-start">
                <div><div><img src="/Assets/images/phone.svg" alt="https://www.flaticon.com/authors/freepik"/></div></div>
                <div>+2 012-0816-1930</div>
            </div>
        </div>
    </div>
</header>
 );
}
 
export default Header

